export default {
  "now-5m": "Last 5 minutes",
  "now-15m": "Last 15 minutes",
  "now-30m": "Last 30 minutes",
  "now-1h": "Last 1 hour",
  "now-3h": "Last 3 hours",
  "now-6h": "Last 6 hours",
  "now-12h": "Last 12 hours",
  "now-24h": "Last 24 hours",
  "now-2d": "Last 2 days",
  "now-7d": "Last 7 days",
  "now-30d": "Last 30 days"
}
